import defaultAuth from "@irati/auth/helpers/defaultAuth"
import authentication from "@irati/auth"
import {Tenant} from "@irati/types"

export default (tenant?: Tenant) => {
  const defaultImage = defaultAuth.userTenant.settings.imageLink
  if (tenant) {
    return tenant.settings.imageLink !== defaultImage
  }
  return authentication.userTenant().settings.imageLink !== defaultImage
}
